import { observer } from 'mobx-react-lite'
import { useTour } from '@reactour/tour'
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined'
import { AppIconButton } from 'src/component/common/analog/molecule/button/AppIconButton'
import { Tooltip } from '@mui/material'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'

export const TourLink = observer(() => {
  const { setIsOpen, setCurrentStep, isOpen, steps } = useTour()
  const { translation } = useLocalizationStore()

  const handleClick = () => {
    ({ isOpen, steps: steps?.length })
    setCurrentStep(0) // Reset to first step
    setIsOpen(true)
  }

  return (
    <AppIconButton onClick={handleClick}
      disableRipple
      sx={{ backgroundColor: 'transparent', '&:hover': { backgroundColor: 'transparent' }, '&:active': { backgroundColor: 'transparent' } }}>
      <Tooltip title={translation.tourSteps.title()} arrow>
        <TipsAndUpdatesOutlinedIcon />
      </Tooltip>
    </AppIconButton>
  )
})